/* 
 * Copyright 2017 Benchmark Software
 * All rights reserved
 */


(function() {

'use strict';


var mobileButtonElement = document.getElementById('mobile-scroll-button'),
    galleryElement = document.getElementById('gallery');

mobileButtonElement.onclick = function(e) {
    e.preventDefault();
    galleryElement.scrollIntoView();
};


Physics(function (world) {
    // bounds of the window
    var viewport = document.getElementById('football-physics')
        ,viewportBounds = Physics.aabb(0, 0, viewport.clientWidth, viewport.clientHeight)
        ,edgeBounce
        ,renderer
        ;

    // create a renderer
    renderer = Physics.renderer('canvas', {
        el: 'football-physics'
    });

    // add the renderer
    world.add(renderer);
    // render on each step
    world.on('step', function () {
        world.render();
    });

    // constrain objects to these bounds
    edgeBounce = Physics.behavior('edge-collision-detection', {
        aabb: viewportBounds
        ,restitution: 0.7
        ,cof: 0.8
    });

    // create some bodies
    var ball = Physics.body('circle', {
        x: parseInt( renderer.width * 0.75, 10 )
        ,y: 100
        ,vx: 0
        ,radius: window.innerWidth < 768 ? 30 : 50
        ,view: window.innerWidth < 768 ? new Image(60,60) : new Image(100,100)
    });
    
    ball.view.src = '/img/football.svg';
    
    world.add(ball);

    // resize events
    window.addEventListener('resize', function () {

        // as of 0.7.0 the renderer will auto resize... so we just take the values from the renderer
        viewportBounds = Physics.aabb(0, 0, renderer.width, renderer.height);
        // update the boundaries
        edgeBounce.setAABB(viewportBounds);
        
        if ( window.innerWidth < 768 ) {
            ball.radius = 30;
            ball.view.width = 60;
            ball.view.height = 60;
        } else {
            ball.radius = 50;
            ball.view.width = 100;
            ball.view.height = 100;
        }

    }, true);

    // add some fun interaction
    var attractor = Physics.behavior('attractor', {
        order: 0,
        strength: 0.0005
    });
    world.on({
        'interact:poke': function( pos ){
            world.wakeUpAll();
            attractor.position( pos );
            world.add( attractor );
        }
        ,'interact:move': function( pos ){
            attractor.position( pos );
        }
        ,'interact:release': function(){
            world.wakeUpAll();
            world.remove( attractor );
        }
    });

    // add things to the world
    world.add([
        Physics.behavior('interactive', {
            el: renderer.container,
            minVel: { x: -2, y: -2 },
            maxVel: { x: 2, y: 2 }
        })
        ,Physics.behavior('constant-acceleration', {
            acc: { x: 0, y: 0.005 }
        })
        ,Physics.behavior('body-impulse-response')
        ,edgeBounce
    ]);

    // subscribe to ticker to advance the simulation
    Physics.util.ticker.on(function( time ) {
        world.step( time );
    });
});


var pswpElement = document.querySelectorAll('.pswp')[0],
    galleryItems = document.getElementById('gallery').getElementsByClassName('gallery-item'),
    pswp = null,
    slides = [];

function openPhotoswipe(index) {
    var pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, slides, {
        index: index,
        showHideOpacity: true,
        tapToClose: true,
        preload: [1,2]
    });
    pswp.init();
}

Array.prototype.forEach.call(galleryItems, function(item){
    var link = item.firstElementChild;
    var slide = {
        el:  link,
        src: link.href,
        w:   link.getAttribute('data-width'),
        h:   link.getAttribute('data-height')
    };
    link.onclick = function(e){
        e.preventDefault();
        openPhotoswipe(parseInt(this.getAttribute('data-index'), 10));
    };
    slides.push(slide);
});


function doGalleryHash() {
    var hash = window.location.hash.substring(1);
    if (hash.length < 5) {
        return;
    }
    
    var vars = hash.split('&');
    var length = vars.length;
    
    for (var i = 0; i < length; i++) {
        var pair = vars[i].split('=');
        if (pair.length > 1 && pair[0] === 'pid') {
            openPhotoswipe( parseInt(pair[1], 10) );
            return;
        }
    }
}
doGalleryHash();


})();